import * as React from 'react';
import ReactCrop, { ReactCropProps } from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

type CropDecoratorProps = ReactCropProps & { className?: string };

export class CropDecorator extends React.Component<CropDecoratorProps> {
    render() {
        return <ReactCrop {...this.props} />;
    }
}
